import React from 'react'
import { Tooltip } from '@mui/material'
import { TOOLTIP_TOUCH_LINGER_MS } from './VoucherBadge'
import { TimeKind } from './columns'
import { t } from '../../../i18n'

const scope = 'orders.time_labels'

const LegendContent = ({ kinds }: { kinds: TimeKind[] }) => (
  <ul className="time-legend">
    {kinds.map((kind) => (
      <li key={kind} className="time-legend__item">
        <span className={`time-legend__dot time-legend__dot--${kind}`} />
        {t(kind, { scope })}
      </li>
    ))}
  </ul>
)

// The time cells carry only coloured timestamps, so this icon is where the colours get their names
const TimeLegend = ({ kinds }: { kinds: TimeKind[] }) => (
  <Tooltip
    title={<LegendContent kinds={kinds} />}
    placement="bottom"
    enterTouchDelay={0}
    leaveTouchDelay={TOOLTIP_TOUCH_LINGER_MS}
    slotProps={{ tooltip: { className: 'time-legend__tooltip' } }}
  >
    <i
      className="bi bi-info-circle time-legend__icon"
      tabIndex={0}
      aria-label={kinds.map((kind) => t(kind, { scope })).join(', ')}
    />
  </Tooltip>
)

export default TimeLegend
